import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

/**
 * Pair of modals for draft management:
 *   1. Resume modal — shown on mount when a saved draft exists.
 *   2. Discard confirmation modal — shown when the user clicks "Descartar" in the status bar.
 */
const IncumplimientoDraftModals = ({
	resumeOpen,
	discardOpen,
	onResume,
	onStartFresh,
	onDiscardConfirm,
	onDiscardCancel,
}) => (
	<>
		<Modal isOpen={resumeOpen} toggle={onStartFresh} centered size='sm' backdrop='static'>
			<ModalHeader toggle={onStartFresh}>Borrador guardado</ModalHeader>
			<ModalBody>
				<p>Tienes un borrador guardado de un formulario incompleto. ¿Deseas continuar donde lo dejaste o empezar de nuevo?</p>
			</ModalBody>
			<ModalFooter>
				<Button color='secondary' outline onClick={onStartFresh}>Empezar de nuevo</Button>
				<Button color='primary' onClick={onResume}>Continuar borrador</Button>
			</ModalFooter>
		</Modal>

		<Modal isOpen={discardOpen} toggle={onDiscardCancel} centered size='sm'>
			<ModalHeader toggle={onDiscardCancel}>Confirmar descarte</ModalHeader>
			<ModalBody>
				<p>¿Estás seguro de que deseas descartar el borrador? Se perderán todos los datos ingresados.</p>
			</ModalBody>
			<ModalFooter>
				<Button color='secondary' outline onClick={onDiscardCancel}>Cancelar</Button>
				<Button color='danger' onClick={onDiscardConfirm}>Descartar borrador</Button>
			</ModalFooter>
		</Modal>
	</>
);

export default IncumplimientoDraftModals;
